module.exports = __webpack_public_path__ + "static/media/MK 10 upd.fc28326c.mp3";